import type { AxiosResponse } from 'axios';
import { markersOfResponseParams } from 'pages/marking/helpers/request-params.helpers';
import { ASSIST_API, requestParams } from 'services/assist-api/axios';
import type { TestInstanceResponseMarkerWithUser } from 'services/assist-api/entities/test-instance-response-marker/types';

export async function getMarkersOfResponse(
  testInstanceResponseId: number
): Promise<AxiosResponse<RequestResponse<TestInstanceResponseMarkerWithUser[]>>> {
  return ASSIST_API.get('test-instance-response-markers', {
    params: requestParams({}, markersOfResponseParams(testInstanceResponseId))
  });
}
